import React from 'react'
import { FaInstagramSquare, FaFacebookSquare, FaShoppingBag } from 'react-icons/fa'

const Footer = () => {
  return (
    <div className='bg-[#0a0a0a] border-t border-gray-800'>
      <div className='max-w-[1240px] mx-auto py-16 px-4 grid md:grid-cols-3 gap-12 text-gray-400'>

        {/* Col 1: Brand */}
        <div>
          <h2 className='text-2xl font-bold text-[#cc2200] mb-3'>SpacePowerGym</h2>
          <p className='text-sm text-gray-500 leading-relaxed mb-4'>
            GoldGym Bodybuilding Team e.V. · Neckartalstrasse 51, 71642 Ludwigsburg
          </p>
          <div className='flex gap-4 mt-4'>
            <a
              href='https://www.facebook.com/spacepowergym/?locale=de_DE'
              target='_blank'
              rel='noopener noreferrer'
              className='hover:text-[#cc2200] transition-colors'
              aria-label='Facebook'
            >
              <FaFacebookSquare size={32} />
            </a>
            <a
              href='https://www.instagram.com/spacepowergym/'
              target='_blank'
              rel='noopener noreferrer'
              className='hover:text-[#cc2200] transition-colors'
              aria-label='Instagram'
            >
              <FaInstagramSquare size={32} />
            </a>
          </div>
        </div>

        {/* Col 2: Kontakt */}
        <div>
          <h3 className='text-white font-bold text-lg mb-4 uppercase tracking-wide'>Kontakt</h3>
          <ul className='space-y-3 text-sm'>
            <li>
              <a href='tel:+4971416856067' className='hover:text-[#cc2200] transition-colors'>
                📞 Tel.: +49 7141 68 56 067
              </a>
            </li>
            <li>
              <a href='tel:+491733604737' className='hover:text-[#cc2200] transition-colors'>
                📱 Mobil: +49 173 36 04 737
              </a>
            </li>
            <li className='pt-2'>
              <span className='text-gray-500'>Neckartalstrasse 51</span><br />
              <span className='text-gray-500'>71642 Ludwigsburg</span>
            </li>
          </ul>
        </div>

        {/* Col 3: Shop */}
        <div>
          <h3 className='text-white font-bold text-lg mb-4 uppercase tracking-wide'>Supplement Shop</h3>
          <p className='text-sm text-gray-500 leading-relaxed mb-5'>
            Unsere eigene Supplement-Linie — entwickelt im SpacePowerGym, geprüft von echten Athleten.
          </p>
          <a
            href='https://spacepower.store'
            target='_blank'
            rel='noopener noreferrer'
            className='inline-flex items-center gap-2 text-white font-bold text-sm px-5 py-3 rounded-lg transition-opacity duration-200 hover:opacity-90'
            style={{background:'#cc2200'}}
          >
            <FaShoppingBag size={16} />
            SpacePower.Store
          </a>
        </div>

      </div>

      {/* Bottom bar */}
      <div className='border-t border-gray-800 py-6 px-4 text-center'>
        <p className='text-gray-600 text-xs'>
          © {new Date().getFullYear()} SpacePowerGym / GoldGym Bodybuilding Team e.V. · Ludwigsburg ·{' '}
          <a href='https://spacepower.store' target='_blank' rel='noopener noreferrer' className='hover:text-[#cc2200]'>
            SpacePower.Store
          </a>
        </p>
      </div>
    </div>
  )
}

export default Footer
